import { page, userPermission } from "../interface/user";
export const ACTION = {
    LIST: 'list',
    ADD: 'new',
    VIEW: 'view'
}
export class UrlServices {
    constructor() { }
    public static DASHBOARD_ROUTE = 'dashboard';
    public static DISPLAY_ROUTE = 'token-display';
    public static ACCESS_DENIED_ROUTE = 'access_denied';
    public static AUTH_PAGE = {
        //USER_ROUTE :
        LOGIN_URL: '/' + 'login',
        FORGOT_PASSWORD_URL: '/' + 'forgotPassword',
        RESET_PASSWORD_URL: '/' + 'reset',
        LOGOUT_URL: '/' + 'logout',
        ACTIVATE: '/' + 'activate'
    }
    public static PAGE_URL: page = {
        EMAIL: {
            LIST: {
                URL: '/email' + '/' + ACTION.LIST,
                permission: {} as userPermission,
            },
            ADD: {
                URL: '/email' + '/' + ACTION.ADD,
                permission: {} as userPermission,
            },
            VIEW: {
                URL: '/email' + '/' + ACTION.VIEW,
                permission: {} as userPermission,
            }
        },

        USER: {
            LIST: {
                URL: '/user' + '/' + ACTION.LIST,
                permission: { moduleName: 'USER', actionName: 'VIEW_ALL' },
            },
            ADD: {
                URL: '/user' + '/' + ACTION.ADD,
                permission: { moduleName: 'USER', actionName: 'ADD' }
            },
            VIEW: {
                URL: '/user' + '/' + ACTION.VIEW,
                permission: { moduleName: 'USER', actionName: 'READ' }
            },
            ROLE: {
                URL: '/user' + '/roles-list',
                permission: { moduleName: 'USER', actionName: 'MANAGE_ROLE' }
            },
            PROFILE: {
                URL: '/patient' + '/' + 'profile',
                permission: { moduleName: 'USER', actionName: 'READ' }
            },
        },
        MASTER: {
            GENERAL: {
                URL: '/master' + '/general',
                permission: { moduleName: 'MASTER', actionName: 'MANAGE_GENERAL' }
            },
            EMAIL: {
                URL: '/master' + '/email',
                permission: { moduleName: 'MASTER', actionName: 'ADD' }
            },
            MEDICINE: {
                URL: '/master' + '/medicine',
                permission: { moduleName: 'MASTER', actionName: 'MANAGE_MEDICINE' }
            },
            PRESCPTION: {
                URL: '/master' + '/prescption',
                permission: { moduleName: 'MASTER', actionName: 'ADD' }
            },
            LOCATION: {
                URL: '/master' + '/location',
                permission: { moduleName: 'MASTER', actionName: 'MANAGE_LOCATION' }
            },
            OFFICE: {
                URL: '/master' + '/office',
                permission: { moduleName: 'MASTER', actionName: 'ADD' }
            },
            LOGSETTINGS: {
                URL: '/master' + '/logsettings',
                permission: { moduleName: 'MASTER', actionName: 'VIEW_LOG' }
            },
            SETTINGS: {
                URL: '/master' + '/settings',
                permission: { moduleName: 'MASTER', actionName: 'ADD' }
            },
            SETTINGSADD: {
                URL: '/master' + '/settingsadd',
                permission: { moduleName: 'MASTER', actionName: 'MANAGE_SETTING' }
            },
            INVOICEADD: {
                URL: '/master' + '/invoicesetting',
                permission: { moduleName: 'MASTER', actionName: 'MANAGE_SETTING' }

            },
            PRESCPTIONADD: {
                URL: '/master' + '/prescptionadd',
                permission: { moduleName: 'MASTER', actionName: 'ADD' }
            },
            PRESCPTIONVIEW: {
                URL: '/master' + '/prescptionview',
                permission: { moduleName: 'MASTER', actionName: 'ADD' }
            },
        },
        PATIENT: {
            LIST: {
                URL: '/patient' + '/' + ACTION.LIST,
                permission: { moduleName: 'PATIENT', actionName: 'VIEW_ALL' } as userPermission,
            },
            ADD: {
                URL: '/patient' + '/' + ACTION.ADD,
                permission: { moduleName: 'PATIENT', actionName: 'ADD' } as userPermission,
            },
            VIEW: {
                URL: '/patient' + '/' + ACTION.VIEW,
                permission: { moduleName: 'PATIENT', actionName: 'READ' } as userPermission,
            },
            PATIENT_TREATMENT: {
                URL: '/patient' + '/' + 'treatment-details',
                permission: { moduleName: 'PATIENT', actionName: 'READ' } as userPermission,
            },

        },
        INVOICE: {
            LIST: {
                URL: '/invoice' + '/' + ACTION.LIST,
                permission: {} as userPermission,
            },
            ADD: {
                URL: '/invoice' + '/' + ACTION.ADD,
                permission: {} as userPermission,
            },
            VIEW: {
                URL: '/invoice' + '/' + ACTION.VIEW,
                permission: {} as userPermission,
            },
            PAYMENTVIEW: {
                URL: '/invoice' + '/' + 'paymentview',
                permission: {} as userPermission,
            }
        },

        EXPENSE: {
            LIST: {
                URL: '/expense' + '/' + ACTION.LIST,
                permission: { moduleName: 'EXPENSE', actionName: 'VIEW_ALL' } as userPermission,
            },
            ADD: {
                URL: '/expense' + '/' + ACTION.ADD,
                permission: { moduleName: 'EXPENSE', actionName: 'ADD' } as userPermission,
            },
            VIEW: {
                URL: '/expense' + '/' + ACTION.VIEW,
                permission: { moduleName: 'EXPENSE', actionName: 'READ' } as userPermission,
            },
        },
        APPOINTMENT: {
            LIST: {
                URL: '/APPOINTMENT' + '/' + ACTION.LIST,
                permission: { moduleName: 'APPOINTMENT', actionName: 'VIEW_ALL' } as userPermission,
            },
            ADD: {
                URL: '/APPOINTMENT' + '/' + ACTION.ADD,
                permission: { moduleName: 'APPOINTMENT', actionName: 'ADD' } as userPermission,
            },
            VIEW: {
                URL: '/APPOINTMENT' + '/' + ACTION.VIEW,
                permission: { moduleName: 'APPOINTMENT', actionName: 'READ' } as userPermission,
            },
            APPOINTMENT_STATUS: {
                URL: '/appointment' + '/' + 'appointment_status',
                permission: { moduleName: 'APPOINTMENT', actionName: 'READ' } as userPermission,
            },
        },
        PAYMENTS: {
            LIST: {
                URL: '/PAYMENTS' + '/' + ACTION.LIST,
                permission: { moduleName: 'PAYMENT', actionName: 'VIEW_ALL' } as userPermission,
            },
            ADD: {
                URL: '/PAYMENTS' + '/' + ACTION.ADD,
                permission: { moduleName: 'PAYMENT', actionName: 'ADD' } as userPermission,
            },
            VIEW: {
                URL: '/PAYMENTS' + '/' + ACTION.VIEW,
                permission: { moduleName: 'PAYMENT', actionName: 'READ' } as userPermission,
            },
        },
        REPORT: {
            LIST: {
                URL: '/REPORT' + '/' + ACTION.LIST,
                permission: {} as userPermission,
            },
            VIEW: {
                URL: '/REPORT' + '/' + ACTION.VIEW,
                permission: {} as userPermission,
            },
        }
    }
}
